import React from 'react';
var WorkBoxContext = React.createContext({
  isUpdateAvailable: false,
  isUpdateActivated: false
});
export default WorkBoxContext;